import MUIDataTable from 'mui-datatables';
import { Box, Grid, Chip, IconButton, Tab, Button, Typography, Tooltip, useMediaQuery } from '@mui/material';
import { variants } from '../../../../variants/variants';
import { useGetAllGiftInterviewsQuery, useSubmitFeedBackMutation } from '../../giftApiSlice';
import { useDispatch, useSelector } from 'react-redux';
import { selectJuniorPendingForms, setPreview } from '../../giftSlice';
import { ArrowRightAltRounded, PreviewOutlined, RateReviewRounded } from '@mui/icons-material';
import { boxBackground, colors } from '../../utility/status';
import { useEffect, useState } from 'react';
import { TabContext, TabList } from '@mui/lab';
import { format } from 'date-fns';
import { Stack } from '@mui/material';
import UserAvatar from '../../../../common/UserAvatar';
import SkeletonTable from '../../../RnR/AdminRnR/SkeletonTable';
import FeedbackForm from '../common/FeedbackForm';
import { useTheme } from '@emotion/react';
import { toggleSwipe } from '../../../Search/searchSlice';
import CustomRow from './CustomRow';
import CustomEmptyTable from '../common/CustomEmptyTable';

const AllGiftInterview = () => {
  const { data, isLoading } = useGetAllGiftInterviewsQuery();
  let interviews = data ? data.data : { Pending: [], Past: [] };
  const dispatch = useDispatch();
  const [result, setResult] = useState('Pending');
  const [selected, setSelected] = useState({ id: null, candidate: null });
  const forms = useSelector(selectJuniorPendingForms);
  const [openFeedback, setOpenFeedback] = useState(false);
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const theme = useTheme();
  let noData = Boolean(!interviews[result] || interviews[result]?.length === 0);

  const handleViewForm = (form) => {
    dispatch(
      setPreview({
        ...form,
        my: false,
      })
    );
  };
  const handleChange = (event, newValue) => {
    setResult(newValue);
  };
  const handleCloseFeedback = (e) => {
    setOpenFeedback(false);
  };
  const handleOpenFeedback = (id, formDetails) => {
    setSelected({ id, formDetails });
    setOpenFeedback(true);
  };
  const handleRowClick = (rowData, { dataIndex }) => {
    dispatch(toggleSwipe({ value: true }));
    window['ReactNativeWebView'] &&
      window['ReactNativeWebView']?.postMessage(JSON.stringify({ type: 'swipe', value: true }));
    handleViewForm({
      response: interviews[result][dataIndex].response,
      currentDesignation: interviews[result][dataIndex].currentDesignation,
      desiredDesignation: interviews[result][dataIndex].desiredDesignation,
      interview: interviews[result][dataIndex].juryDetails,
    });
  };

  const columns = [
    { name: '_id', options: { display: false } },
    {
      name: 'employeeDetails',
      label: isMobile ? 'Application' : 'Employee',
      options: {
        sort: false,
        display: noData ? false : true,
        customBodyRenderLite: (dataIndex) => {
          let gift = interviews[result][dataIndex];
          const val = interviews[result][dataIndex]?.employeeDetails;
          const currentDesignation = interviews[result][dataIndex].currentDesignation?.split(' - ')[0];
          const desiredDesignation = interviews[result][dataIndex].desiredDesignation?.split(' - ')[0];
          return isMobile ? (
            <CustomRow gift={gift} handleOpenFeedback={handleOpenFeedback} result={result} />
          ) : (
            <Box>
              <Typography sx={{ fontSize: variants.BODY }}>{val?.empName}</Typography>
              <Stack direction={'row'} alignItems={'center'}>
                <Typography sx={{ fontSize: variants.TINY }}>{currentDesignation}</Typography>
                <ArrowRightAltRounded />
                <Typography sx={{ fontSize: variants.TINY }}>{desiredDesignation}</Typography>
              </Stack>
            </Box>
          );
        },
      },
    },
    {
      name: 'currentDesignation',
      label: 'From',
      options: {
        sort: false,
        display: false,
        customBodyRender: (value) => {
          return <Typography sx={{ fontSize: variants.BODY }}>{value?.split(' - ')[0]}</Typography>;
        },
      },
    },
    {
      name: 'desiredDesignation',
      label: 'To',
      options: {
        sort: false,
        display: false,

        customBodyRender: (value) => {
          return <Typography sx={{ fontSize: variants.BODY }}>{value?.split(' - ')[0]}</Typography>;
        },
      },
    },
    {
      name: 'submissionDate',
      label: 'Submitted',
      options: {
        sort: false,
        display: !isMobile,
        customBodyRender: (value) => {
          return <Typography sx={{ fontSize: variants.BODY }}>{new Date(value).toLocaleDateString()}</Typography>;
        },
      },
    },
    {
      name: 'juryMeetingDate',
      label: 'Jury Meeting',
      options: {
        sort: false,
        display: !isMobile,

        customBodyRender: (value) => {
          return <Typography sx={{ fontSize: variants.BODY }}>{format(new Date(value), 'PPpp')}</Typography>;
        },
      },
    },
    {
      name: 'juryDetails',
      label: 'Jury details',
      options: {
        sort: false,
        display: !isMobile,

        customBodyRender: (value) => {
          return value?.map((member, index) => {
            return (
              <Stack direction={'row'} key={index} alignItems={'center'} sx={{ mb: 1 }}>
                <UserAvatar src={member.employeePhotoPath} sx={{ width: 30, height: 30 }} />
                <Typography sx={{ fontSize: variants.TINY, ml: 1 }}>{member.empName}</Typography>
              </Stack>
            );
          });
        },
      },
    },
    {
      name: 'feedbackForm',
      label: 'Feedback',
      options: {
        sort: false,
        display: isMobile ? false : result === 'Completed' ? (noData ? false : true) : false,
        customBodyRenderLite: (dataIndex) => {
          const id = interviews[result][dataIndex]._id;
          const formDetails = interviews[result][dataIndex];
          return (
            <Tooltip title={'Feedback Form'}>
              <IconButton
                variant='outlined'
                sx={{ borderColor: colors.Pass, color: colors.Pass }}
                onClick={() => handleOpenFeedback(id, formDetails)}
              >
                <RateReviewRounded fontSize='small' sx={{ color: colors.Pending }} />
              </IconButton>
            </Tooltip>
          );
        },
      },
    },
    {
      name: 'response',
      label: 'Application',
      options: {
        filter: false,
        sort: false,
        display: !isMobile,

        customBodyRenderLite: (dataIndex) => {
          let interview = interviews[result][dataIndex];
          let value = interview?.response;
          let currentDesignation = interview?.currentDesignation;
          let desiredDesignation = interview?.desiredDesignation;
          return (
            <IconButton
              size='small'
              onClick={() =>
                handleViewForm({
                  response: value,
                  currentDesignation,
                  desiredDesignation,
                  interview: interview?.juryDetails,
                })
              }
            >
              <PreviewOutlined />
            </IconButton>
          );
        },
      },
    },
  ];
  if (isLoading)
    return (
      <Grid xs={12} md={8}>
        <SkeletonTable />
      </Grid>
    );

  return (
    <Grid
      item
      xs={12}
      md={8}
      sx={{
        height: '100%',
        background: isMobile ? '' : variants.boxBackground.PROFILE_CARD,
        borderRadius: variants.boxRadius.MAIN,
        p: 1,
        pb: 0,
        [theme.breakpoints.down('lg')]: {
          px: 0,
          '& .MuiTableCell-footer': {
            p: 0,
            border: 0,
          },
        },
      }}
    >
      <Box
        sx={{
          border: 1,
          background: '#fff',
          borderColor: 'divider',
          borderRadius: variants.boxRadius.MAIN,
          height:"100%"
        }}
      >
        <TabContext value={result}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: isMobile ? 0 : 2 }}>
            <TabList onChange={handleChange}>
              {Object.keys(interviews)?.map((res, index) => {
                return (
                  <Tab
                    sx={{ fontSize: variants.TINY, color: colors[res] }}
                    key={index}
                    label={
                      <span>
                        {res}
                        <span
                          style={{
                            marginLeft: '0.5rem',
                            paddingBlock: '0.15rem',
                            paddingInline: '0.75rem',
                            background: boxBackground[res],
                            borderRadius: 5,
                            color: colors[res],
                          }}
                        >
                          {(interviews && interviews[res]?.length) || 0}
                        </span>
                      </span>
                    }
                    value={res}
                  />
                );
              })}
            </TabList>
          </Box>
        </TabContext>
        <MUIDataTable
          title={''}
          data={interviews[result]}
          columns={columns}
          options={{
            elevation: 0,
            selectableRows: 'none',
            rowsPerPage: 5,
            rowsPerPageOptions: [5, 10, 20],
            viewColumns: false,
            tableBodyHeight: `calc(100vh - ${isMobile ? '245px' : '265px'})`,
            search: false,
            download: false,
            filter: false,
            print: false,
            onRowClick: isMobile ? handleRowClick : () => {},
            responsive: 'standard',
          }}
          components={{
            ...(noData && {
              TableBody: CustomEmptyTable,
            }),
          }}
        />
        <FeedbackForm open={openFeedback} handleClose={handleCloseFeedback} selected={selected} />
      </Box>
    </Grid>
  );
};

export default AllGiftInterview;
